/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Webplatform-ts V3 API
 * OpenAPI spec version: 3.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BroadcastV3EmbeddedWalletTransaction200,
  BroadcastV3EmbeddedWalletTransactionBody,
  GetV3EmbeddedWalletAccountTransfers200,
  GetV3EmbeddedWalletAccountTransfersParams,
  GetV3EmbeddedWalletBalances200,
  GetV3EmbeddedWalletPassphraseDownloadStatus200,
  GetV3EmbeddedWalletTransactionStatus200,
  GetV3EmbeddedWalletTransactionStatusParams,
  GetV3TurnkeyAccountIsSigner200,
  GetV3TurnkeyRecoveryStatus200,
  GetV3TurnkeySigners200,
  GetV3TurnkeySuborgId200,
  ListV3EmbeddedWalletAccounts200Item,
  ListV3EmbeddedWalletProviders200,
  MarkV3EmbeddedWalletPassphraseDownloaded200,
  NotifyV3EmbeddedWalletSigner200,
  NotifyV3EmbeddedWalletSignerBody,
  SyncV3EmbeddedWalletProvider200,
  SyncV3EmbeddedWalletProviderBody
} from '../../model';

import { webplatformProxyInstance } from '../../../../../lib/integrations/axios.ts';
import type { ErrorType } from '../../../../../lib/integrations/axios.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Relays the exact transaction returned by Turnkey signTransaction after verifying its signer belongs to this organization's embedded-wallet account. Retry an indeterminate result with the same signed transaction; never sign a replacement until the original is confirmed unable to execute.
 * @summary Broadcast a signed embedded-wallet transaction
 */
export const broadcastV3EmbeddedWalletTransaction = (
    id: string,
    broadcastV3EmbeddedWalletTransactionBody: BroadcastV3EmbeddedWalletTransactionBody,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<BroadcastV3EmbeddedWalletTransaction200>(
      {url: `/v3/embedded-wallets/accounts/${id}/broadcast`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: broadcastV3EmbeddedWalletTransactionBody, signal
    },
      options);
    }




export const getBroadcastV3EmbeddedWalletTransactionMutationKey = () => ['broadcastV3EmbeddedWalletTransaction'] as const;

export const getBroadcastV3EmbeddedWalletTransactionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof broadcastV3EmbeddedWalletTransaction>>, TError,BroadcastV3EmbeddedWalletTransactionMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof broadcastV3EmbeddedWalletTransaction>>, TError,BroadcastV3EmbeddedWalletTransactionMutationVariables, TContext> => {

const mutationKey = getBroadcastV3EmbeddedWalletTransactionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof broadcastV3EmbeddedWalletTransaction>>, BroadcastV3EmbeddedWalletTransactionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  broadcastV3EmbeddedWalletTransaction(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BroadcastV3EmbeddedWalletTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof broadcastV3EmbeddedWalletTransaction>>>
    export type BroadcastV3EmbeddedWalletTransactionMutationBody = BroadcastV3EmbeddedWalletTransactionBody
    export type BroadcastV3EmbeddedWalletTransactionMutationError = ErrorType<unknown>
    export type BroadcastV3EmbeddedWalletTransactionMutationVariables = {id: string;data: BroadcastV3EmbeddedWalletTransactionBody}

    /**
 * @summary Broadcast a signed embedded-wallet transaction
 */
export const useBroadcastV3EmbeddedWalletTransaction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof broadcastV3EmbeddedWalletTransaction>>, TError,BroadcastV3EmbeddedWalletTransactionMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof broadcastV3EmbeddedWalletTransaction>>,
        TError,
        BroadcastV3EmbeddedWalletTransactionMutationVariables,
        TContext
      > => {
      return useMutation(getBroadcastV3EmbeddedWalletTransactionMutationOptions(options), queryClient);
    }
    /**
 * Returns every embedded-wallet provider and the organization's enrollment with it, keyed by provider.
 * @summary List embedded wallet providers and the organization's enrollment
 */
export const listV3EmbeddedWalletProviders = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<ListV3EmbeddedWalletProviders200>(
      {url: `/v3/embedded-wallets/providers`, method: 'GET', signal
    },
      options);
    }




export const getListV3EmbeddedWalletProvidersQueryKey = () => {
    return [
    `/v3/embedded-wallets/providers`
    ] as const;
    }


export const getListV3EmbeddedWalletProvidersQueryOptions = <TData = Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListV3EmbeddedWalletProvidersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>> = ({ signal }) => listV3EmbeddedWalletProviders(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListV3EmbeddedWalletProvidersQueryResult = NonNullable<Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>>
export type ListV3EmbeddedWalletProvidersQueryError = ErrorType<unknown>


export function useListV3EmbeddedWalletProviders<TData = Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>,
          TError,
          Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListV3EmbeddedWalletProviders<TData = Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>,
          TError,
          Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListV3EmbeddedWalletProviders<TData = Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List embedded wallet providers and the organization's enrollment
 */

export function useListV3EmbeddedWalletProviders<TData = Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listV3EmbeddedWalletProviders>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListV3EmbeddedWalletProvidersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns every wallet account provisioned for the authenticated organization's Turnkey sub-org. One account is one address; a Turnkey wallet holds several.
 * @summary List the organization's embedded wallet accounts
 */
export const listV3EmbeddedWalletAccounts = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<ListV3EmbeddedWalletAccounts200Item[]>(
      {url: `/v3/embedded-wallets/accounts`, method: 'GET', signal
    },
      options);
    }




export const getListV3EmbeddedWalletAccountsQueryKey = () => {
    return [
    `/v3/embedded-wallets/accounts`
    ] as const;
    }


export const getListV3EmbeddedWalletAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListV3EmbeddedWalletAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>> = ({ signal }) => listV3EmbeddedWalletAccounts(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListV3EmbeddedWalletAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>>
export type ListV3EmbeddedWalletAccountsQueryError = ErrorType<unknown>


export function useListV3EmbeddedWalletAccounts<TData = Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>,
          TError,
          Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListV3EmbeddedWalletAccounts<TData = Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>,
          TError,
          Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListV3EmbeddedWalletAccounts<TData = Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the organization's embedded wallet accounts
 */

export function useListV3EmbeddedWalletAccounts<TData = Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listV3EmbeddedWalletAccounts>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListV3EmbeddedWalletAccountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns recent transfer history per provisioned chain for the embedded wallet. EVM chains route through Alchemy's alchemy_getAssetTransfers (native + ERC20); Solana routes through Helius's getTransactionsForAddress. Only tokens in the wallet's configured asset set are surfaced; a chain that fails to read is reported as unavailable rather than empty.
 * @summary Get an embedded wallet account's recent transfers
 */
export const getV3EmbeddedWalletAccountTransfers = (
    id: string,
    params?: GetV3EmbeddedWalletAccountTransfersParams,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<GetV3EmbeddedWalletAccountTransfers200>(
      {url: `/v3/embedded-wallets/accounts/${id}/transfers`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetV3EmbeddedWalletAccountTransfersQueryKey = (id: string,
    params?: GetV3EmbeddedWalletAccountTransfersParams,) => {
    return [
    `/v3/embedded-wallets/accounts/${id}/transfers`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetV3EmbeddedWalletAccountTransfersQueryOptions = <TData = Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>, TError = ErrorType<unknown>>(id: string,
    params?: GetV3EmbeddedWalletAccountTransfersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV3EmbeddedWalletAccountTransfersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>> = ({ signal }) => getV3EmbeddedWalletAccountTransfers(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV3EmbeddedWalletAccountTransfersQueryResult = NonNullable<Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>>
export type GetV3EmbeddedWalletAccountTransfersQueryError = ErrorType<unknown>


export function useGetV3EmbeddedWalletAccountTransfers<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>, TError = ErrorType<unknown>>(
 id: string,
    params: undefined |  GetV3EmbeddedWalletAccountTransfersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>,
          TError,
          Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3EmbeddedWalletAccountTransfers<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetV3EmbeddedWalletAccountTransfersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>,
          TError,
          Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3EmbeddedWalletAccountTransfers<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetV3EmbeddedWalletAccountTransfersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an embedded wallet account's recent transfers
 */

export function useGetV3EmbeddedWalletAccountTransfers<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetV3EmbeddedWalletAccountTransfersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletAccountTransfers>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV3EmbeddedWalletAccountTransfersQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns AUSD, USDC, and native gas balances for the embedded wallet, per chain. Each balance carries a raw integer base-unit string and a formatted decimal string alongside the token's decimals; an unreadable balance is reported as unavailable, never as zero.
 * @summary Get an embedded wallet's balances
 */
export const getV3EmbeddedWalletBalances = (
    id: string,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<GetV3EmbeddedWalletBalances200>(
      {url: `/v3/embedded-wallets/accounts/${id}/balances`, method: 'GET', signal
    },
      options);
    }




export const getGetV3EmbeddedWalletBalancesQueryKey = (id: string,) => {
    return [
    `/v3/embedded-wallets/accounts/${id}/balances`
    ] as const;
    }


export const getGetV3EmbeddedWalletBalancesQueryOptions = <TData = Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV3EmbeddedWalletBalancesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>> = ({ signal }) => getV3EmbeddedWalletBalances(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV3EmbeddedWalletBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>>
export type GetV3EmbeddedWalletBalancesQueryError = ErrorType<unknown>


export function useGetV3EmbeddedWalletBalances<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>,
          TError,
          Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3EmbeddedWalletBalances<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>,
          TError,
          Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3EmbeddedWalletBalances<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an embedded wallet's balances
 */

export function useGetV3EmbeddedWalletBalances<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletBalances>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV3EmbeddedWalletBalancesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Reports whether the account's wallet passphrase download has been attested, along with the employee who first downloaded it and when. The fields are null until it is downloaded.
 * @summary Get whether an embedded wallet's passphrase has been downloaded
 */
export const getV3EmbeddedWalletPassphraseDownloadStatus = (
    id: string,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<GetV3EmbeddedWalletPassphraseDownloadStatus200>(
      {url: `/v3/embedded-wallets/accounts/${id}/passphrase-download`, method: 'GET', signal
    },
      options);
    }




export const getGetV3EmbeddedWalletPassphraseDownloadStatusQueryKey = (id: string,) => {
    return [
    `/v3/embedded-wallets/accounts/${id}/passphrase-download`
    ] as const;
    }


export const getGetV3EmbeddedWalletPassphraseDownloadStatusQueryOptions = <TData = Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV3EmbeddedWalletPassphraseDownloadStatusQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>> = ({ signal }) => getV3EmbeddedWalletPassphraseDownloadStatus(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV3EmbeddedWalletPassphraseDownloadStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>>
export type GetV3EmbeddedWalletPassphraseDownloadStatusQueryError = ErrorType<unknown>


export function useGetV3EmbeddedWalletPassphraseDownloadStatus<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>,
          TError,
          Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3EmbeddedWalletPassphraseDownloadStatus<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>,
          TError,
          Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3EmbeddedWalletPassphraseDownloadStatus<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get whether an embedded wallet's passphrase has been downloaded
 */

export function useGetV3EmbeddedWalletPassphraseDownloadStatus<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletPassphraseDownloadStatus>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV3EmbeddedWalletPassphraseDownloadStatusQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Attests that the calling employee downloaded the account's wallet passphrase. Attested exactly once: a second attempt is rejected with a conflict rather than overwriting who first downloaded it.
 * @summary Record that the caller downloaded an embedded wallet's passphrase
 */
export const markV3EmbeddedWalletPassphraseDownloaded = (
    id: string,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<MarkV3EmbeddedWalletPassphraseDownloaded200>(
      {url: `/v3/embedded-wallets/accounts/${id}/passphrase-download`, method: 'POST', signal
    },
      options);
    }




export const getMarkV3EmbeddedWalletPassphraseDownloadedMutationKey = () => ['markV3EmbeddedWalletPassphraseDownloaded'] as const;

export const getMarkV3EmbeddedWalletPassphraseDownloadedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markV3EmbeddedWalletPassphraseDownloaded>>, TError,MarkV3EmbeddedWalletPassphraseDownloadedMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markV3EmbeddedWalletPassphraseDownloaded>>, TError,MarkV3EmbeddedWalletPassphraseDownloadedMutationVariables, TContext> => {

const mutationKey = getMarkV3EmbeddedWalletPassphraseDownloadedMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markV3EmbeddedWalletPassphraseDownloaded>>, MarkV3EmbeddedWalletPassphraseDownloadedMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  markV3EmbeddedWalletPassphraseDownloaded(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkV3EmbeddedWalletPassphraseDownloadedMutationResult = NonNullable<Awaited<ReturnType<typeof markV3EmbeddedWalletPassphraseDownloaded>>>

    export type MarkV3EmbeddedWalletPassphraseDownloadedMutationError = ErrorType<unknown>
    export type MarkV3EmbeddedWalletPassphraseDownloadedMutationVariables = {id: string}

    /**
 * @summary Record that the caller downloaded an embedded wallet's passphrase
 */
export const useMarkV3EmbeddedWalletPassphraseDownloaded = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markV3EmbeddedWalletPassphraseDownloaded>>, TError,MarkV3EmbeddedWalletPassphraseDownloadedMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markV3EmbeddedWalletPassphraseDownloaded>>,
        TError,
        MarkV3EmbeddedWalletPassphraseDownloadedMutationVariables,
        TContext
      > => {
      return useMutation(getMarkV3EmbeddedWalletPassphraseDownloadedMutationOptions(options), queryClient);
    }
    /**
 * Reads the current on-chain status of a transaction on one of the chains embedded wallets provision. Status is normalized across VMs: pending (not yet mined, or unknown to the node), confirmed, failed, or unavailable when the read itself fails. An unavailable result carries a retryable flag so the caller can decide whether to poll again.
 * @summary Get the on-chain status of an embedded-wallet transaction
 */
export const getV3EmbeddedWalletTransactionStatus = (
    params: GetV3EmbeddedWalletTransactionStatusParams,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<GetV3EmbeddedWalletTransactionStatus200>(
      {url: `/v3/embedded-wallets/transaction-status`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetV3EmbeddedWalletTransactionStatusQueryKey = (params?: GetV3EmbeddedWalletTransactionStatusParams,) => {
    return [
    `/v3/embedded-wallets/transaction-status`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetV3EmbeddedWalletTransactionStatusQueryOptions = <TData = Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>, TError = ErrorType<unknown>>(params: GetV3EmbeddedWalletTransactionStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV3EmbeddedWalletTransactionStatusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>> = ({ signal }) => getV3EmbeddedWalletTransactionStatus(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV3EmbeddedWalletTransactionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>>
export type GetV3EmbeddedWalletTransactionStatusQueryError = ErrorType<unknown>


export function useGetV3EmbeddedWalletTransactionStatus<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>, TError = ErrorType<unknown>>(
 params: GetV3EmbeddedWalletTransactionStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>,
          TError,
          Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3EmbeddedWalletTransactionStatus<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>, TError = ErrorType<unknown>>(
 params: GetV3EmbeddedWalletTransactionStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>,
          TError,
          Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3EmbeddedWalletTransactionStatus<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>, TError = ErrorType<unknown>>(
 params: GetV3EmbeddedWalletTransactionStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the on-chain status of an embedded-wallet transaction
 */

export function useGetV3EmbeddedWalletTransactionStatus<TData = Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>, TError = ErrorType<unknown>>(
 params: GetV3EmbeddedWalletTransactionStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3EmbeddedWalletTransactionStatus>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV3EmbeddedWalletTransactionStatusQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Idempotent write. Dispatched by `provider`; for turnkey, resolves the caller's sub-org by canonical name and inserts any missing TurnkeyOrganizationDetail / EmbeddedWalletDetail / CustomerAddress rows. Always returns 200; each provider's outcome (success or soft error) lives on its own key so the caller can render a soft state.
 * @summary Reconcile the org's embedded-wallet provider enrollment into the app DB
 */
export const syncV3EmbeddedWalletProvider = (
    syncV3EmbeddedWalletProviderBody: SyncV3EmbeddedWalletProviderBody,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<SyncV3EmbeddedWalletProvider200>(
      {url: `/v3/embedded-wallets/provider/sync`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: syncV3EmbeddedWalletProviderBody, signal
    },
      options);
    }




export const getSyncV3EmbeddedWalletProviderMutationKey = () => ['syncV3EmbeddedWalletProvider'] as const;

export const getSyncV3EmbeddedWalletProviderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncV3EmbeddedWalletProvider>>, TError,SyncV3EmbeddedWalletProviderMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof syncV3EmbeddedWalletProvider>>, TError,SyncV3EmbeddedWalletProviderMutationVariables, TContext> => {

const mutationKey = getSyncV3EmbeddedWalletProviderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncV3EmbeddedWalletProvider>>, SyncV3EmbeddedWalletProviderMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  syncV3EmbeddedWalletProvider(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncV3EmbeddedWalletProviderMutationResult = NonNullable<Awaited<ReturnType<typeof syncV3EmbeddedWalletProvider>>>
    export type SyncV3EmbeddedWalletProviderMutationBody = SyncV3EmbeddedWalletProviderBody
    export type SyncV3EmbeddedWalletProviderMutationError = ErrorType<unknown>
    export type SyncV3EmbeddedWalletProviderMutationVariables = {data: SyncV3EmbeddedWalletProviderBody}

    /**
 * @summary Reconcile the org's embedded-wallet provider enrollment into the app DB
 */
export const useSyncV3EmbeddedWalletProvider = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncV3EmbeddedWalletProvider>>, TError,SyncV3EmbeddedWalletProviderMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof syncV3EmbeddedWalletProvider>>,
        TError,
        SyncV3EmbeddedWalletProviderMutationVariables,
        TContext
      > => {
      return useMutation(getSyncV3EmbeddedWalletProviderMutationOptions(options), queryClient);
    }
    /**
 * Publishes `embedded-wallet/root-user.added` so the new signer is emailed to log in and set up their credentials. The signer is created client-side via the Turnkey SDK; the backend validates the employee is a signer in the org's Turnkey sub-org before publishing. Publish is deduplicated per (org, signer) within a short window, so a client retry after a transient failure re-sends without double-emailing.
 * @summary Email a new signer to finish credential setup
 */
export const notifyV3EmbeddedWalletSigner = (
    notifyV3EmbeddedWalletSignerBody: NotifyV3EmbeddedWalletSignerBody,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<NotifyV3EmbeddedWalletSigner200>(
      {url: `/v3/embedded-wallets/provider/turnkey/signers/notify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notifyV3EmbeddedWalletSignerBody, signal
    },
      options);
    }




export const getNotifyV3EmbeddedWalletSignerMutationKey = () => ['notifyV3EmbeddedWalletSigner'] as const;

export const getNotifyV3EmbeddedWalletSignerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyV3EmbeddedWalletSigner>>, TError,NotifyV3EmbeddedWalletSignerMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notifyV3EmbeddedWalletSigner>>, TError,NotifyV3EmbeddedWalletSignerMutationVariables, TContext> => {

const mutationKey = getNotifyV3EmbeddedWalletSignerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notifyV3EmbeddedWalletSigner>>, NotifyV3EmbeddedWalletSignerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  notifyV3EmbeddedWalletSigner(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotifyV3EmbeddedWalletSignerMutationResult = NonNullable<Awaited<ReturnType<typeof notifyV3EmbeddedWalletSigner>>>
    export type NotifyV3EmbeddedWalletSignerMutationBody = NotifyV3EmbeddedWalletSignerBody
    export type NotifyV3EmbeddedWalletSignerMutationError = ErrorType<unknown>
    export type NotifyV3EmbeddedWalletSignerMutationVariables = {data: NotifyV3EmbeddedWalletSignerBody}

    /**
 * @summary Email a new signer to finish credential setup
 */
export const useNotifyV3EmbeddedWalletSigner = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyV3EmbeddedWalletSigner>>, TError,NotifyV3EmbeddedWalletSignerMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notifyV3EmbeddedWalletSigner>>,
        TError,
        NotifyV3EmbeddedWalletSignerMutationVariables,
        TContext
      > => {
      return useMutation(getNotifyV3EmbeddedWalletSignerMutationOptions(options), queryClient);
    }
    /**
 * Resolves the caller's Turnkey sub-org id from our DB first, falling back to list_suborgs filtered by the canonical name derived from organizationId. Returns null when no suborg exists yet. Used by enrollment flows to check for a pre-existing suborg before creating one.
 * @summary Get the org's Turnkey sub-org id
 */
export const getV3TurnkeySuborgId = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<GetV3TurnkeySuborgId200>(
      {url: `/v3/embedded-wallets/provider/turnkey/suborg`, method: 'GET', signal
    },
      options);
    }




export const getGetV3TurnkeySuborgIdQueryKey = () => {
    return [
    `/v3/embedded-wallets/provider/turnkey/suborg`
    ] as const;
    }


export const getGetV3TurnkeySuborgIdQueryOptions = <TData = Awaited<ReturnType<typeof getV3TurnkeySuborgId>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeySuborgId>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV3TurnkeySuborgIdQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV3TurnkeySuborgId>>> = ({ signal }) => getV3TurnkeySuborgId(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeySuborgId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV3TurnkeySuborgIdQueryResult = NonNullable<Awaited<ReturnType<typeof getV3TurnkeySuborgId>>>
export type GetV3TurnkeySuborgIdQueryError = ErrorType<unknown>


export function useGetV3TurnkeySuborgId<TData = Awaited<ReturnType<typeof getV3TurnkeySuborgId>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeySuborgId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3TurnkeySuborgId>>,
          TError,
          Awaited<ReturnType<typeof getV3TurnkeySuborgId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3TurnkeySuborgId<TData = Awaited<ReturnType<typeof getV3TurnkeySuborgId>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeySuborgId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3TurnkeySuborgId>>,
          TError,
          Awaited<ReturnType<typeof getV3TurnkeySuborgId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3TurnkeySuborgId<TData = Awaited<ReturnType<typeof getV3TurnkeySuborgId>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeySuborgId>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the org's Turnkey sub-org id
 */

export function useGetV3TurnkeySuborgId<TData = Awaited<ReturnType<typeof getV3TurnkeySuborgId>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeySuborgId>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV3TurnkeySuborgIdQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Resolves the caller's email from their employee record and checks, via list_users, whether it is among the users of the org's recorded Turnkey sub-org. Uses the core API (unaffected by the Auth Proxy verification-token gate). Used by the auth flow to branch signin vs blocked-teammate before sending an OTP.
 * @summary Check whether the caller is the org's Turnkey signer
 */
export const getV3TurnkeyAccountIsSigner = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<GetV3TurnkeyAccountIsSigner200>(
      {url: `/v3/embedded-wallets/provider/turnkey/account/is-signer`, method: 'GET', signal
    },
      options);
    }




export const getGetV3TurnkeyAccountIsSignerQueryKey = () => {
    return [
    `/v3/embedded-wallets/provider/turnkey/account/is-signer`
    ] as const;
    }


export const getGetV3TurnkeyAccountIsSignerQueryOptions = <TData = Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV3TurnkeyAccountIsSignerQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>> = ({ signal }) => getV3TurnkeyAccountIsSigner(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV3TurnkeyAccountIsSignerQueryResult = NonNullable<Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>>
export type GetV3TurnkeyAccountIsSignerQueryError = ErrorType<unknown>


export function useGetV3TurnkeyAccountIsSigner<TData = Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>,
          TError,
          Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3TurnkeyAccountIsSigner<TData = Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>,
          TError,
          Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3TurnkeyAccountIsSigner<TData = Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check whether the caller is the org's Turnkey signer
 */

export function useGetV3TurnkeyAccountIsSigner<TData = Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeyAccountIsSigner>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV3TurnkeyAccountIsSignerQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Reads, with the parent key, whether the org's Turnkey sub-org exists, whether the caller is its signer, and for the signer only, whether SMS recovery is on (the recovery login rule demands an SMS code) and the E.164 number it uses. Recovery runs before any Turnkey session exists, so the browser cannot read this from Turnkey itself. Nothing is stored in the app DB.
 * @summary Get the org's embedded-wallet recovery setup
 */
export const getV3TurnkeyRecoveryStatus = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<GetV3TurnkeyRecoveryStatus200>(
      {url: `/v3/embedded-wallets/provider/turnkey/recovery`, method: 'GET', signal
    },
      options);
    }




export const getGetV3TurnkeyRecoveryStatusQueryKey = () => {
    return [
    `/v3/embedded-wallets/provider/turnkey/recovery`
    ] as const;
    }


export const getGetV3TurnkeyRecoveryStatusQueryOptions = <TData = Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV3TurnkeyRecoveryStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>> = ({ signal }) => getV3TurnkeyRecoveryStatus(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV3TurnkeyRecoveryStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>>
export type GetV3TurnkeyRecoveryStatusQueryError = ErrorType<unknown>


export function useGetV3TurnkeyRecoveryStatus<TData = Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>,
          TError,
          Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3TurnkeyRecoveryStatus<TData = Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>,
          TError,
          Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3TurnkeyRecoveryStatus<TData = Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the org's embedded-wallet recovery setup
 */

export function useGetV3TurnkeyRecoveryStatus<TData = Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeyRecoveryStatus>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV3TurnkeyRecoveryStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Reads, with the parent key, the root users of the org's Turnkey sub-org (get_organization) and matches each to an active org member by email. Phone numbers are left out. Returns an empty list when the org has no sub-org. Nothing is stored in the app DB.
 * @summary List the signers of the org's embedded wallet
 */
export const getV3TurnkeySigners = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<GetV3TurnkeySigners200>(
      {url: `/v3/embedded-wallets/provider/turnkey/signers`, method: 'GET', signal
    },
      options);
    }




export const getGetV3TurnkeySignersQueryKey = () => {
    return [
    `/v3/embedded-wallets/provider/turnkey/signers`
    ] as const;
    }


export const getGetV3TurnkeySignersQueryOptions = <TData = Awaited<ReturnType<typeof getV3TurnkeySigners>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeySigners>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV3TurnkeySignersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV3TurnkeySigners>>> = ({ signal }) => getV3TurnkeySigners(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeySigners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV3TurnkeySignersQueryResult = NonNullable<Awaited<ReturnType<typeof getV3TurnkeySigners>>>
export type GetV3TurnkeySignersQueryError = ErrorType<unknown>


export function useGetV3TurnkeySigners<TData = Awaited<ReturnType<typeof getV3TurnkeySigners>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeySigners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3TurnkeySigners>>,
          TError,
          Awaited<ReturnType<typeof getV3TurnkeySigners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3TurnkeySigners<TData = Awaited<ReturnType<typeof getV3TurnkeySigners>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeySigners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3TurnkeySigners>>,
          TError,
          Awaited<ReturnType<typeof getV3TurnkeySigners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3TurnkeySigners<TData = Awaited<ReturnType<typeof getV3TurnkeySigners>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeySigners>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the signers of the org's embedded wallet
 */

export function useGetV3TurnkeySigners<TData = Awaited<ReturnType<typeof getV3TurnkeySigners>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3TurnkeySigners>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV3TurnkeySignersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






